export default __webpack_public_path__ + "static/media/art-red-banner-2.87323de2.jpg";